import { defineStore } from 'pinia';
import state from './state.js';
import getters from './getters.js';
import actions from './actions.js';

const useAuthStore = defineStore('auth', {
	state,
	actions,
	getters,
	persist: true,
});

export default useAuthStore;
